import {Injectable} from '@angular/core'
import {Store} from '@ngrx/store'
import {RouterNavigatedAction, routerNavigatedAction} from '@ngrx/router-store';
import {Actions, concatLatestFrom, createEffect, ofType} from '@ngrx/effects'
import {noop} from 'rxjs';
import {map, switchMap, tap} from 'rxjs/operators'
import {PersistStoreService} from './persist-store.service'
import {RouterStateUrl} from '../router/router.model';
import {correlationIdWithStoreStateSelector} from '../store-root.selector'
import {pobierzStore, pobranoStoreSuccess} from './persist-store.actions';
import {zapiszStore} from '../../../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/store/ekran-podsumowania.actions';

@Injectable()
export class PersistStoreEffects {

  constructor(private store: Store,
              private actions$: Actions,
              private persistService: PersistStoreService) {
  }

  readStore$ = createEffect(() => this.actions$.pipe(
    ofType(pobierzStore),
    switchMap((action) => {
      return this.persistService.readStore(action.correlationId).pipe(
        map((storeState) => pobranoStoreSuccess(storeState)));
    })
  ));

  saveStore$ = createEffect(() => this.actions$.pipe(
    ofType<RouterNavigatedAction<RouterStateUrl>>(routerNavigatedAction),
    concatLatestFrom((action) => this.store.select(correlationIdWithStoreStateSelector)),
    tap(([action, correlationIdWithStoreState]) => {
      if (this.shouldPersistStore(action, correlationIdWithStoreState.correlationId)) {
        this.persistService.saveStore(correlationIdWithStoreState.correlationId, correlationIdWithStoreState.storeState).pipe().subscribe(noop);
      }
    })
    ), {dispatch: false}
  );

  saveStoreManually$ = createEffect(() => this.actions$.pipe(
      ofType(zapiszStore),
      concatLatestFrom((action) => this.store.select(correlationIdWithStoreStateSelector)),
      tap(([action, correlationIdWithStoreState]) => {
        this.persistService.saveStore(correlationIdWithStoreState.correlationId, correlationIdWithStoreState.storeState).pipe().subscribe(noop);
      })
    ), {dispatch: false}
  );

  /** Parametr - shouldPersistStoreAfterReachingRoute: boolean służy do sterowania mechanizmem utrwalania Store.
   * Warunkiem koniecznym do uruchomienia mechanizmu zapisującego Store jest zdefiniowanie parametru
   * 'shouldPersistStoreAfterReachingRoute' w polu 'data' obiektu Route (@angular/router)
   * oraz ustawieniu jego wartości na 'true'.
   *
   * Przykład definicji obiektu Route (@angular/router) po którego osiągnięciu należy wywołać mechanizm utrwalania Store:
   *   {path: '/sciezkaPoKtorejOsiagnieciuPowinienNastapicZapisStore',
   *   pathMatch: 'full' , component: ComponentDoUtworzeniaWMomencieGdySciezkaJestZgodnaZWprowadzonymUrl,
   *   data: {shouldPersistStoreAfterReachingRoute: true}}
   */
  private shouldPersistStore(action: RouterNavigatedAction<RouterStateUrl>, correlationId: string): boolean {
    return action.payload.routerState.data.shouldPersistStoreAfterReachingRoute && correlationId;
  }
}
